(function () {
  'use strict';
  document.querySelectorAll('.collection-guide__copy').forEach(function (copy) {
    if (copy.dataset.compact) return;
    var paragraphs = Array.prototype.slice.call(copy.children).filter(function (el) {
      return el.tagName === 'P';
    });
    if (paragraphs.length < 2) return;
    var details = document.createElement('details');
    details.className = 'collection-guide__actions';
    details.innerHTML = '<summary>Compare flavours and ingredients</summary><div></div>';
    var body = details.querySelector('div');
    paragraphs.slice(1).forEach(function (paragraph) { body.appendChild(paragraph); });
    paragraphs[0].insertAdjacentElement('afterend', details);
    copy.dataset.compact = '1';
  });
})();
